import loadable from '@loadable/component';

// export const ImmersiveReader = loadable(() =>
//   import(
//     /* webpackChunkName: "DCPTViews" */ './test/test'
//   ),
// );

export RERImmersiveReader from 'rer-theme/components/ImmersiveReader/RERImmersiveReader';

export const InvalidatePageAction = loadable(() =>
  import(
    /* webpackChunkName: "InvalidatePageAction" */ './InvalidatePageAction/InvalidatePageAction'
  ),
);
